import React, { useState } from "react";
import Modal from "react-modal";
import SearchNButtons from "../../common-components/SearchNButtons";
import DietPlanForm from "../diet-dashboard/DietPlanForm";

const DietPlanFilters = ({
  filters,
  setFilters,
  searchFilterApplied,
  onClickSearch,
  handleKeyPress,
  callFunction
}) => {
  const [dietPlanModal, setDietPlanModal] = useState(false);

  const onCloseModal = () => {
    setDietPlanModal(false);
  };

  return (
    <>
      <Modal
        isOpen={dietPlanModal}
        onRequestClose={onCloseModal}
        contentLabel="Add Diet Plan Modal"
        ariaHideApp={false}
      >
        <DietPlanForm onCloseModal={onCloseModal} callFunction={callFunction} />
      </Modal>

      <SearchNButtons
        pageName={"diet-plan"}
        btnText={"+ Add Diet Plan"}
        filters={filters}
        setFilters={setFilters}
        searchFilterApplied={searchFilterApplied}
        onClickSearch={onClickSearch}
        onClickAdd={() => setDietPlanModal(true)}
        handleKeyPress={handleKeyPress}
      />
    </>
  );
};

export default DietPlanFilters;
